import fetcher from "@onair/utils/fetch-api";
import { EventCategory } from "@onair/types";
import {
	Pagination,
	FindOneFilter,
	FindManyFilter,
	FindUniqueFilter,
} from "@onair/types/extends";
import { Event, EventV2, EventV2Response } from "@onair/repositories";

export const actionGetCategory = async (
	slug: string,
	filter?: FindUniqueFilter<EventCategory>,
): Promise<EventCategory> => {
	const data = await fetcher<EventCategory>(`/event-categories/${slug}`, {
		data: {
			filter: JSON.stringify(filter),
		},
	});

	return data;
};

export const actionGetCategoryList = async (
	filter?: FindManyFilter<EventCategory>,
): Promise<Pagination<EventCategory>> => {
	const data = await fetcher<Pagination<EventCategory>>("/event-categories", {
		data: {
			filter: JSON.stringify(filter),
		},
	});

	return data;
};

export const actionGetEventList = async (
	filter?: FindManyFilter<EventV2>,
): Promise<Pagination<Partial<EventV2Response>>> => {
	const data = await fetcher<Pagination<EventV2Response>>("/events", {
		data: {
			filter: JSON.stringify({
				...filter,
				include: {
					product: true,
					host: {
						select: {
							id: true,
							fullName: true,
							username: true,
							avatar: true,
							job: true,
						},
					},
					...filter?.include,
				},
			}),
		},
	});

	return data;
};

export const actionGetMineEventList = async (
	filter?: FindManyFilter<Event>,
): Promise<Pagination<Event>> => {
	const data = await fetcher<Pagination<Event>>("/events/mine", {
		data: {
			filter: JSON.stringify({
				...filter,
				include: {
					product: true,
					...filter?.include,
				},
			}),
		},
	});

	return data;
};

export const actionGetEventDetails = async (
	slug: string,
	filter?: FindOneFilter<Event>,
): Promise<Event> => {
	const data = await fetcher<Event>("/events/" + slug, {
		data: {
			filter: JSON.stringify(filter),
		},
	});

	return data;
};

export const actionCreateEvent = async (
	payload: Omit<
		Event,
		| "id"
		| "top"
		| "deletedAt"
		| "isDeleted"
		| "createdAt"
		| "updatedAt"
		| "hostId"
		| "slug"
		| "duration"
		| "durationType"
		| "roomUrl"
		| "categories"
	> & { categories: { value: string; label: string }[] },
): Promise<Event> => {
	const data = await fetcher<Event>("/events", {
		method: "POST",
		data: payload,
	});

	return data;
};

export const actionUpdateEvent = async (
	id: string,
	payload: Partial<
		Omit<
			Event,
			| "id"
			| "top"
			| "deletedAt"
			| "isDeleted"
			| "createdAt"
			| "updatedAt"
			| "hostId"
			| "slug"
			| "duration"
			| "durationType"
			| "roomUrl"
			| "categories"
		> & { categories: { value: string; label: string }[] }
	>,
): Promise<Event> => {
	const data = await fetcher<Event>("/events/" + id, {
		method: "PATCH",
		data: payload,
	});

	return data;
};

export const actionGetTrendingEventOnEventDetail = async (id: string) => {
	const data = await fetcher("/events/trending-on-event-detail/" + id, {
		method: "GET",
	});

	return data as Event[];
};

export const actionGetTrendingEventOnCart = async (id: string) => {
	const data = await fetcher("/events/trending-on-cart/" + id, {
		method: "GET",
	});

	return data as { uniqueEvents: Event[] };
};
